(function (global) {
  const captureCheckoutPreviewPng = (canvas) => {
    if (!canvas || typeof canvas.toDataURL !== "function") {
      throw new Error("The checkout preview snapshot is unavailable.");
    }
    const snapshot = canvas.toDataURL("image/png");
    if (!snapshot.startsWith("data:image/png;base64,")) {
      throw new Error("The checkout preview snapshot is invalid.");
    }
    return snapshot;
  };

  const buildInput = (state) => ({
    variantId: String(state.variantId),
    text: String(state.text || ""),
    fontFamily: String(state.fontFamily),
    colorHex: String(state.colorHex).toUpperCase(),
    colorName: String(state.colorName),
    sizePercent: Number(state.sizePercent),
    xPercent: Number(state.xPercent),
    yPercent: Number(state.yPercent),
    rotationDeg: Number(state.rotationDeg),
    checkoutPreviewPng: String(state.checkoutPreviewPng || "")
  });

  const saveDraft = async (input, idempotencyKey) => {
    const response = await fetch("/apps/kova-designs/designs/drafts", {
      method: "POST",
      headers: {Accept: "application/json", "Content-Type": "application/json"},
      body: JSON.stringify({...input, idempotencyKey})
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.message || "Unable to save your design. Please try again.");
    const validReceipt = body &&
      /^dsg_[0-9a-f]{32}$/.test(body.designId) &&
      body.designVersion === 1 &&
      /^sha256:[0-9a-f]{64}$/.test(body.checksum);
    if (!validReceipt) {
      throw new Error("The design service returned an invalid design receipt.");
    }
    return body;
  };

  const api = Object.freeze({buildInput, captureCheckoutPreviewPng, saveDraft});
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  global.KovaDesignContract = api;
})(globalThis);
